module.exports = __webpack_public_path__ + "img/Vector 7.48deb093.png";